import React from 'react';
import { Link } from 'react-router-dom';
import './PaymentsInfo.css';

export default function PaymentsInfo() {
  const steps = [
    ['1', 'Browse services or post a request', 'Buyers review published skill services, provider profiles, packages, pricing, and delivery notes before starting an order.'],
    ['2', 'Confirm scope and checkout', 'After the buyer and provider agree on the service scope, the buyer opens the platform checkout page with the service title, amount, and delivery notes.'],
    ['3', 'Pay through platform checkout', 'Oblitrok supports Alipay automatic checkout for buyer payments.'],
    ['4', 'Track delivery and settlement', 'The platform keeps payment records, order status, messages, evidence, refunds, and dispute handling inside the user account area.'],
  ];

  const policies = [
    'Payments are used for skill services, requirement collaboration, and related digital or professional service orders.',
    'The checkout flow is available after login because it is connected to the buyer account, service context, and order records.',
    'Automatic payment confirmation is synchronized through the platform backend and provider webhook events.',
    'Refunds, order disputes, and settlement questions are handled through platform support and the finance center.',
  ];

  return (
    <div className="payments-info-page">
      <section className="payments-hero">
        <div className="container payments-hero-inner">
          <div>
            <p className="payments-kicker">Payment flow</p>
            <h1>Secure checkout for Oblitrok service orders</h1>
            <p>
              Oblitrok is a skill service marketplace for international buyers and providers.
              Buyers can discover services, request work, confirm order details, and complete
              platform checkout when a service order is ready for payment.
            </p>
          </div>
          <div className="payments-summary" aria-label="Payment summary">
            <span>Payment methods</span>
            <strong>Alipay</strong>
            <span>Website</span>
            <strong>oblitrok.com</strong>
          </div>
        </div>
      </section>

      <main className="container payments-main">
        <section className="payments-panel">
          <div className="payments-section-head">
            <p className="payments-kicker">How buyers pay</p>
            <h2>Order and payment process</h2>
          </div>
          <div className="payments-steps">
            {steps.map(([number, title, body]) => (
              <article className="payments-step" key={number}>
                <div className="payments-step-number">{number}</div>
                <h3>{title}</h3>
                <p>{body}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="payments-grid">
          <article className="payments-panel">
            <div className="payments-section-head">
              <p className="payments-kicker">Checkout location</p>
              <h2>Where checkout is used</h2>
            </div>
            <p>
              The live checkout page is part of the logged-in buyer account area. A buyer reaches
              checkout from a service booking or a platform order and then continues through
              Alipay automatic checkout.
            </p>
            <div className="payments-actions">
              <Link to="/services" className="btn btn-primary">Browse services</Link>
              <Link to="/checkout" className="btn btn-outline">Open checkout</Link>
            </div>
          </article>

          <article className="payments-panel">
            <div className="payments-section-head">
              <p className="payments-kicker">Business use</p>
              <h2>Payment scope</h2>
            </div>
            <ul className="payments-policy-list">
              {policies.map(policy => <li key={policy}>{policy}</li>)}
            </ul>
          </article>
        </section>

        <section className="payments-panel payments-support">
          <div>
            <p className="payments-kicker">Review notes</p>
            <h2>Payment integration status</h2>
            <p>
              The website is prepared for Alipay automatic checkout. Payment
              confirmation is handled by the platform backend after the merchant account receives
              the provider notification.
            </p>
          </div>
          <Link to="/help" className="btn btn-ghost">Support information</Link>
        </section>
      </main>
    </div>
  );
}
